import { Checkbox, FormControlLabel } from '@mui/material';

import type { NotAttendingSchoolCheckboxProps } from './types';

export default function NotAttendingSchoolCheckbox({
  checked,
  disabled = false,
  onChange,
}: NotAttendingSchoolCheckboxProps) {
  return (
    <FormControlLabel
      sx={{ alignSelf: 'flex-start' }}
      control={
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={(_event, value) => onChange(value)}
        />
      }
      label="Child is not attending school"
    />
  );
}
